import React, { FC } from "react";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon";
import { useMail } from "contexts/mailContext/mailContext";
import { ActionExpandedComponent } from "../Reusable/MailActionsComponent.js";
import { useUser } from "contexts/userContext/userContext.js";
import type { MailDataI } from "models/models.js";

interface ReuploadActionComponentProps {
  mailData: MailDataI;
  isFromSplitPanel?: boolean;
}

interface SplitPanelActionComponentProps {
  reuploadACtion: () => void;
  tooltipTextKey: string;
}

const SplitPanelActionComponent: FC<SplitPanelActionComponentProps> = ({
  reuploadACtion,
  tooltipTextKey,
}) => {
  return (
    <ActionExpandedComponent
      iconName="cloud-upload"
      textKey={tooltipTextKey}
      clickAction={reuploadACtion}
    />
  );
};

const ReuploadActionComponent: FC<ReuploadActionComponentProps> = ({
  mailData,
  isFromSplitPanel,
}) => {
  const { setReuploadingMail, getReuploadingMail } = useMail();
  const { getUserData } = useUser();

  const mailId = mailData.id;

  const conditionToShowReupload = () => {
    const collaborationOptions = mailData?.security?.collaboration;

    if (mailData.mailStatus === "removed") return false;

    if (getUserData().UserName === mailData?.SenderInfo?.senderEmail) {
      return true;
    }

    if (collaborationOptions === "recipients") {
      return mailData?.recipientsList?.includes(getUserData().UserName);
    } else if (collaborationOptions === "link") {
      return true;
    } else if (collaborationOptions === "organization") {
      const topUserEmail = getUserData().TopUserEmail;
      const senderEmail = mailData?.SenderInfo?.senderEmail;
      const topSenderEmail = mailData?.SenderInfo?.topUserEmail;
      return topSenderEmail === topUserEmail || senderEmail === topUserEmail;
    }
  };

  const handleClick = () => {
    if (!getReuploadingMail()) {
      setReuploadingMail(mailId);
    }
  };

  if (!conditionToShowReupload() || mailData.mailStatus === "uploading")
    return null;

  return isFromSplitPanel ? (
    <SplitPanelActionComponent
      reuploadACtion={handleClick}
      tooltipTextKey="reupload-icon-tooltip"
    />
  ) : (
    <div className="reupload-inbox-icon-container" onClick={handleClick}>
      <Tooltip tooltipTextKey="reupload-icon-tooltip">
        <Icon name="cloud-upload" blue />
      </Tooltip>
    </div>
  );
};
export default ReuploadActionComponent;
